export default __webpack_public_path__ + "static/courses-details-c6564e4bf1377087ef50cd0e55f8b124.jpg";